import React, { useState } from 'react';
import Swiper from 'react-id-swiper'
import 'swiper/css/swiper.css'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
// mui
// import Card from '@material-ui/core/Card'
// import CardActionArea from '@material-ui/core/CardActionArea'
// import CardMedia from '@material-ui/core/CardMedia';

const PickUpSwiper = props => {
    const dispatch = useDispatch()

    const [params] = useState({
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        grabCursor: true,
        breakpoints: {
            960: {
              slidesPerView: 3,
              spaceBetween: 30
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            }
          }
    })

    const magazines = props.magazineList
    let images = []
    magazines.map(magazine => {
        return images.push(magazine.image)
    })

    return (
        <Swiper {...params}>
            <ImageWrapper><Image src={images[0]?.path} alt='swiper-0' onClick={()=>dispatch(push('/magazine/dp/' + magazines[0].id))} /></ImageWrapper>
            <ImageWrapper><Image src={images[1]?.path} alt='swiper-1' onClick={()=>dispatch(push('/magazine/dp/' + magazines[1].id))} /></ImageWrapper>
            <ImageWrapper><Image src={images[2]?.path} alt='swiper-2' onClick={()=>dispatch(push('/magazine/dp/' + magazines[2].id))}/></ImageWrapper>
            <ImageWrapper><Image src={images[3]?.path} alt='swiper-3' onClick={()=>dispatch(push('/magazine/dp/' + magazines[3].id))}/></ImageWrapper>
            <ImageWrapper><Image src={images[4]?.path} alt='swiper-4' onClick={()=>dispatch(push('/magazine/dp/' + magazines[4].id))} /></ImageWrapper>
            <ImageWrapper><Image src={images[5]?.path} alt='swiper-5' onClick={()=>dispatch(push('/magazine/dp/' + magazines[5].id))} /></ImageWrapper>
            <ImageWrapper><Image src={images[6]?.path} alt='swiper-6' onClick={()=>dispatch(push('/magazine/dp/' + magazines[6].id))} /></ImageWrapper>
            {/* <ImageWrapper><Image src={images[7]?.path} alt='swiper-7' onClick={()=>dispatch(push('/magazine/dp/' + magazines[7].id))} /></ImageWrapper>
            <ImageWrapper><Image src={images[8]?.path} alt='swiper-8' onClick={()=>dispatch(push('/magazine/dp/' + magazines[8].id))} /></ImageWrapper> */}
        </Swiper>
        
    )
};
export default PickUpSwiper;

const ImageWrapper = styled.div`
    width: 300px;
    height: 400px;
    background-color: #7ABECE;
`
const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 1s all; 
    filter: saturate(0%);
    &:hover {
        transition: 1s all;
        opacity: 0.5;
        display:block;
    }
`